export default class Numbers {
    public static isNumber = (value: any): boolean => !(value === undefined || value === '' || isNaN(Number(value)))

    public static toNotional = (notional: number): string=> notional.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")

    public static parse = (str: string) =>  parseFloat(str.replace(/,/g, ''));
}